// extracted by mini-css-extract-plugin
module.exports = {"menuListSection":"menu-list-section_menuListSection__DkMcT","title":"menu-list-section_title__4hKXi"};